// extracted by mini-css-extract-plugin
module.exports = {"LongArrow":"LongArrow-module--LongArrow--3vLDM","icon":"LongArrow-module--icon--24ROT","icon__disabled":"LongArrow-module--icon__disabled--B0_r1"};